import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, OverviewCard } from "../../components";
import {
  detailPageTabs,
  generalIcons,
  userBulletinOverview,
} from "../../utils/constants";
import UserBulletin from "./UserBulletin";
import { useStakingContext } from "../../context/staking-context";
import DelegatorDataTable from "../../components/dataTable/DelegatorDataTable";
import { getValidatorImg } from "../../utils/helper";
import { getSingleDocument } from "../../utils/firebase.helper";
import { usePublicClient } from "wagmi";
import { isAddress } from "viem";

export default function DetailPage() {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const { selectedValidator, setSelectedValidator, overviewTooltipDetail, fetchValidatorDelegators, fetchIsValidator } = useStakingContext();
  const { id } = useParams();
  const [isFetchingDelegator, setIsFertchingDelegator] = useState(true)

  const [isFetching, setIsFetching] = useState(true)

  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [validatorDelegators, setValidatorDelegators] = useState([])
  const [validatorStake, setValidatorStake] = useState(0)
  const [currentLastDoc, setCurrentLastDoc] = useState(null)
  const publicClient = usePublicClient(); // Get the client for interacting with the blockchain.

  const handleDelegators = async () => {
    try {
      const  {allData, lastDoc} = await fetchValidatorDelegators(id ?? selectedValidator?.contract_address, currentLastDoc)
      if(allData?.length > 0){
        setValidatorDelegators((prev)=>[...prev, ...allData])
        setCurrentLastDoc(lastDoc)
        setIsLoadingMore(false)
      }else{
        setHasMore(false)
        setIsLoadingMore(false)
      }
      setIsFertchingDelegator(false)
    } catch (error) {
      console.log({error})
    }
  }
  const handleIsValidator = async () => {
    try {
      const data = await fetchIsValidator(id ?? selectedValidator?.contract_address, selectedValidator?.ownerWallet)
      setValidatorStake(data?.stake_value || 0)
      setIsFetching(false)
    } catch (error) {
      console.log({error})
    }
  }
  const handleCurrentValidator = async () => {
    try {
      const data = await getSingleDocument("/vanar-dpos/data/validators",id)

      if(data?.status === "inactive"){
        navigate("/")
      }else{
        const obj = {
          name: data?.name,
          performance: data?.performance ?? 0,
          commission: `${(data?.commission * 100)}%` ?? 0,
          contract_address: data?.contract_address,
          checkpoint_signed: data?.checkpoint_signed,
          total_staked: data?.total_staked,
          total_rewards_distributed: data?.total_rewards_generated,
          health_status: "Healthy",
          validator_stake: "",
          status: data?.status,
          ownerWallet: data?.owner_wallet_address
        };
        setSelectedValidator(obj)
        localStorage?.setItem("selectedValidator", JSON.stringify(obj));
      }

    } catch (error) {
      console.log({error})
    }
  }


  const checkAddress = async (address) => {
    try {
      if (!isAddress(address) || !id) {
        navigate("/");
        return;
      }
    } catch (error) {
      console.error(`Error checking address ${address}:`, error);
    }
  };


  useEffect(() => {
    checkAddress(id)
    if(selectedValidator?.contract_address !== id){
      navigate("/")
    }
    handleDelegators();

    if(selectedValidator?.contract_address === ""){
      handleCurrentValidator()
    }

    if(selectedValidator?.ownerWallet){
      handleIsValidator()
    }

  }, [selectedValidator]);

  return (
    <div className="relative h-auto pb-16 lg:pb-[100px]">
      <Container>
        <div className="flex items-center">
          <Link
            to={"/"}
            className="flex items-center -tracking-08 w-fit text-xs md:text-xsm font-medium text- dim"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full">
              {generalIcons.backArrow}
            </div>
            <span className="opacity-[50%] mr-1">Overview / </span>{" "}
          </Link>
          <span className="text-xs md:text-xsm">{selectedValidator?.name}</span>
        </div>

        <div className="relative mt-11">
          <div className="relative w-fit mx-auto laptop:mx-0 flex items-center gap-4">
            <div className="w-10 h-10 laptop:w-[54px] laptop:h-[54px] flex items-center justify-center">
              <img
                src= {getValidatorImg(selectedValidator?.name)}
                alt=""
                className="max-w-full max-h-full"
              />
            </div>
            <h1 className="text-[30px] md:text-[64px] text-textcolor font-bold lg:-tracking-37 leading-none md:leading-[64px]">
              {selectedValidator?.name}{" "}
            </h1>
          </div>

          <UserBulletin selectedValidator={selectedValidator} />

          <div className="bg-[#191919]/40 rounded-[18px] p-4 lg:p-8 laptop:py-10 laptop:px-[38px] border-[1.5px] border-[#1A1A1A]/40 mt-8 lg:mt-10 laptop:mt-[50px]">
            <h3 className="text-lg md:text-xl lg:text-[22px] lg:leading-[22px] font-semibold -tracking-12 text-[#DADADA]">
              Staking Overview
            </h3>

            <div className="grid grid-cols-2 lg:grid-cols-3 laptop:grid-cols-4 gap-5 mt-5 lg:mt-[30px] detail-over-card">
              {Object.entries(userBulletinOverview)?.map(([key, value]) => (
                <div className="col-span-1" key={key}>
                  <OverviewCard
                    title={key}
                    value={selectedValidator[key] ?? 0}
                    info={true}
                    overviewTooltipDetail={overviewTooltipDetail}
                    validatorStake={validatorStake}
                    isFetching={isFetching}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-4 mt-16 mb-5 flex-col md:flex-row">
          <div className="flex items-center rounded-xl bg-[#1A1A1A] text-primaryWhite/50 gap-2 text-sm lg:text-base leading-none font-medium *:h-12 *:whitespace-nowrap w-full md:w-fit *:w-full *:sm:w-[50%] *:md:w-fit">
            {Object.entries(detailPageTabs).map(([key, value]) => (
              <div
                key={key}
                className={`flex items-center justify-center capitalize py-[10px] px-6 rounded-xl bg-primaryWhite text-[#06080C]`}
              >
                {value} {validatorDelegators?.length}
              </div>
            ))}
          </div>
        </div>
        <div className="overflow-hidden rounded-3xl">
          <DelegatorDataTable
            filteredAndSorteddelegadators={validatorDelegators}
            validatorName={selectedValidator?.name}
            hasMore={hasMore}
            setHasMore={setHasMore}
            isLoadingMore={isLoadingMore}
            setIsLoadingMore={setIsLoadingMore}
            status={selectedValidator?.status}
            isUndefined={isFetchingDelegator}
            handleDelegators={handleDelegators}
          />
        </div>
      </Container>
    </div>
  );
}
